import { CapoPlugin } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];